import React, { useMemo, useState } from 'react';
import { PropTypes } from 'prop-types';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import Iconify from '../../Iconify';
import ImgBox from '../Box/ImgBox';

const Type = styled(Box)(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  zIndex: 999999999,
  height: '100%',
  background: 'rgba(66, 66, 66, 0.7)',
  borderRadius: '6px',
  transition: 'background 0.3s, opacity 1s',
  '&:hover': {
    background: 'rgba(66, 66, 66, 0.3)',
  },
  '&.hide': {
    opacity: '0',
  },
}));

const CustIcon = styled(Iconify)(() => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  color: '#FFF',
  fontSize: '2rem',
}));

const CustText = styled('div')(() => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  color: '#FFF',
  fontSize: '2rem',
}));

const CustomImageBox = styled('div')(() => ({
  position: 'relative',
  display: 'inline-block !important',
  verticalAlign: 'top',
  margin: '8px 1%',
  width: '23%',
  objectFit: 'cover',
  borderRadius: '6px',
  aspectRatio: '4 / 3',
  cursor: 'pointer',
  overflow: 'hidden',
  zIndex: 10,
}));

const CustomImage = styled(ImgBox)(() => ({
  position: 'absolute',
  width: '100%',
  height: '100%',
  aspectRatio: '4 / 3',
  objectFit: 'cover',
}));

DigitalObjectsList.propTypes = {
  objects: PropTypes.array,
  onClick: PropTypes.func,
  active: PropTypes.any,
};

export default function DigitalObjectsList({ objects, onClick, active }) {
  const [showMore, setShowMore] = useState(false);

  const checkValid = (object) => {
    switch (object?.type) {
      case '3D_MODEL':
        return object?.model?.fileUrl !== undefined;
      default:
        return true;
    }
  };

  const count = useMemo(() => {
    let tmpCount = 0;
    objects.forEach((obj) => {
      if (checkValid(obj)) {
        tmpCount += 1;
      }
    });
    return tmpCount;
  }, [objects]);

  const showImages = useMemo(() => {
    let cnt = 0;
    return objects.map((obj, idx) => {
      const valid = checkValid(obj);
      if (valid) cnt += 1;
      return (
        (showMore || cnt <= 3 || count === 4) &&
        valid && (
          <CustomImageBox key={idx} onClick={() => onClick(idx, obj)}>
            <CustomImage src={obj?.thumbnail?.fileUrl} />
            <Type className={active === obj ? 'hide' : ''}>
              {obj.type === 'SPHERICAL_PANORAMA' && <CustIcon icon="fa6-solid:panorama" />}
              {obj.type === 'OBJECT_PANORAMA' && <CustIcon icon="bi:globe" />}
              {obj.type === 'images' && <CustIcon icon="fa-regular:image" />}
              {obj.type === 'IMAGES' && <CustIcon icon="fa-regular:image" />}
              {obj.type === 'VIDEO' && <CustIcon icon="fa-regular:play-circle" />}
              {obj.type === 'AUDIO' && <CustIcon icon="fa:music" />}
              {obj.type === 'DOWNLOAD' && <CustIcon icon="ic:outline-cloud-download" />}
              {obj.type === 'BOOK' && <CustIcon icon="material-symbols:menu-book-outline" />}
              {obj.type === '3D_MODEL' && <CustIcon icon="material-symbols:3d-rotation" />}
            </Type>
          </CustomImageBox>
        )
      );
    });
  }, [active, objects, showMore, onClick, count]);

  return (
    <div>
      {count > 1 && showImages}
      {count > 4 && (
        <CustomImageBox onClick={() => setShowMore((old) => !old)}>
          <CustomImage src={''} />
          <Type>
            <CustText>
              {showMore ? '-' : '+'}
              {count - 3}
            </CustText>
          </Type>
        </CustomImageBox>
      )}
    </div>
  );
}
